window.addEventListener('turbo:load', () => {
  const container = document.querySelector('[data-prices]');
  if (!container) return;

  const searchInput = container.querySelector('[data-prices-search]');
  const clinicSelect = container.querySelector('[data-prices-clinic]');
  const emptyMessage = container.querySelector('[data-prices-empty]');
  const categories = Array.from(container.querySelectorAll('[data-price-category]'));

  // Treat ё and е as the same letter when searching.
  const normalize = (value) => (value || '').toLowerCase().replace(/ё/g, 'е');

  const filter = () => {
    const query = normalize(searchInput.value).trim();
    const clinicId = clinicSelect ? clinicSelect.value : '';

    let anyVisible = false;

    categories.forEach((category) => {
      const subcategories = Array.from(category.querySelectorAll('[data-price-subcategory]'));
      let categoryHasVisible = false;

      subcategories.forEach((sub) => {
        const cards = Array.from(sub.querySelectorAll('[data-service-name]'));
        let subHasVisible = false;

        cards.forEach((card) => {
          const name = normalize(card.dataset.serviceName);
          const clinics = (card.dataset.clinics || '').split(' ');
          const matchesName = !query || name.includes(query);
          const matchesClinic = !clinicId || clinics.includes(clinicId);
          const visible = matchesName && matchesClinic;
          card.style.display = visible ? '' : 'none';
          if (visible) subHasVisible = true;
        });

        sub.style.display = subHasVisible ? '' : 'none';
        if (subHasVisible) categoryHasVisible = true;
      });

      category.style.display = categoryHasVisible ? '' : 'none';
      if (categoryHasVisible) anyVisible = true;
    });

    if (emptyMessage) emptyMessage.hidden = anyVisible;
  };

  searchInput.addEventListener('input', filter);
  if (clinicSelect) clinicSelect.addEventListener('change', filter);
  filter();
});
